export default __webpack_public_path__ + "static/media/full3.ac6c41bc.jpg";